module.exports = __webpack_public_path__ + "img/t8.9291e9c1.png";